import React from "react";
import Index from "../views/dashboard/index";
// import { Switch, Route } from 'react-router-dom'
// user
import UserProfile from "../views/dashboard/app/user-profile";
import UserAdd from "../views/dashboard/app/user-add";
import UserList from "../views/dashboard/app/user-list";
// import userProfileEdit from '../views/dashboard/app/user-privacy-setting';
// widget
import Widgetbasic from "../views/dashboard/widget/widgetbasic";
import Widgetcard from "../views/dashboard/widget/widgetcard";
import Widgetchart from "../views/dashboard/widget/widgetchart";
// icon
import Solid from "../views/dashboard/icons/solid";
import Outline from "../views/dashboard/icons/outline";
import DualTone from "../views/dashboard/icons/dual-tone";
// Form
import FormElement from "../views/dashboard/from/form-element";
import FormValidation from "../views/dashboard/from/form-validation";
import FormWizard from "../views/dashboard/from/form-wizard";
// table
import BootstrapTable from "../views/dashboard/table/bootstrap-table";
import TableData from "../views/dashboard/table/table-data";

// map
import Vector from "../views/dashboard/maps/vector";
import Google from "../views/dashboard/maps/google";

//extra
// import PrivacyPolicy from '../views/dashboard/extra/privacy-policy';
// import TermsofService from '../views/dashboard/extra/terms-of-service';

//TransitionGroup
// import { TransitionGroup, CSSTransition } from "react-transition-group";
//Special Pages
import Billing from "../views/dashboard/special-pages/billing";
import Kanban from "../views/dashboard/special-pages/kanban";
import Pricing from "../views/dashboard/special-pages/pricing";
import Timeline from "../views/dashboard/special-pages/timeline";
import Calender from "../views/dashboard/special-pages/calender";
import RtlSupport from "../views/dashboard/special-pages/RtlSupport";

//admin
import Admin from "../views/dashboard/admin/admin";
import Default from "../layouts/dashboard/default";
import VendorList from "../views/dashboard/app/vendor-listing";
import CustomerList from "../views/dashboard/app/customer-listing";
import KYCManager from "../views/dashboard/kyc/KYCManager";
import JobDetail from "../views/dashboard/job/JobDetail";
import JobList from "../views/dashboard/job/JobList";
import ProtectedRoute from "../components/auth/ProtectedRoute";
import EquipmentManager from "../views/dashboard/EquipmentManager/EquipmentManager";

import CropTypeManager from "../views/dashboard/crop";
import Refferals from "../views/dashboard/refferal/refferalManager";
import PaymentSettlement from "../views/dashboard/payment-settlement/payment-settlement";
import NewPayment from "../views/dashboard/payment-settlement/newPayment";
import FAQManager from "../views/dashboard/faq/faq";
import LabelManager from "../views/dashboard/label/label";
import NewReferralManage from "../views/dashboard/refferal/newReferralManage";

export const DefaultRouter = [
  {
    path: "/",
    element: <Default />,
    children: [
      {
        path: "dashboard",
        element: (
          <ProtectedRoute>
            <Index />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/billing",
        element: (
          <ProtectedRoute>
            <Billing />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/calender",
        element: (
          <ProtectedRoute>
            <Calender />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/kanban",
        element: (
          <ProtectedRoute>
            <Kanban />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/app/kyc",
        element: (
          <ProtectedRoute>
            <KYCManager />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/pricing",
        element: (
          <ProtectedRoute>
            <Pricing />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/timeline",
        element: (
          <ProtectedRoute>
            <Timeline />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/special-pages/rtl-support",
        element: (
          <ProtectedRoute>
            <RtlSupport />
          </ProtectedRoute>
        ),
      },
      {
        path: "/jobs",
        element: (
          <ProtectedRoute>
            <JobList />
          </ProtectedRoute>
        ),
      },
      // { path: "/refferals", element: <Refferals /> },
      { path: "/refferals-manage", element: <NewReferralManage /> },
      { path: "/payment-settlement", element: <NewPayment /> },
      {
        path: "/faq",
        element: <FAQManager />,
      },
      {
        path: "/label",
        element: <LabelManager />,
      },
      {
        path: "dashboard/app/user-add",
        element: (
          <ProtectedRoute>
            <UserAdd />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/app/user-list",
        element: (
          <ProtectedRoute>
            <UserList />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/app/vendor-listing",
        element: (
          <ProtectedRoute>
            <VendorList />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/app/customer-listing",
        element: (
          <ProtectedRoute>
            <CustomerList />
          </ProtectedRoute>
        ),
      },
      {
        path: "/equipments",
        element: <EquipmentManager />,
      },
      {
        path: "dashboard/crop",
        element: (
          <ProtectedRoute>
            <CropTypeManager />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/admin/admin",
        element: (
          <ProtectedRoute>
            <Admin />
          </ProtectedRoute>
        ),
      },
      // Widget
      {
        path: "dashboard/widget/widgetbasic",
        element: (
          <ProtectedRoute>
            <Widgetbasic />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/widget/widgetchart",
        element: (
          <ProtectedRoute>
            <Widgetchart />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/widget/widgetcard",
        element: (
          <ProtectedRoute>
            <Widgetcard />
          </ProtectedRoute>
        ),
      },
      // Map
      {
        path: "dashboard/map/google",
        element: (
          <ProtectedRoute>
            <Google />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/map/vector",
        element: (
          <ProtectedRoute>
            <Vector />
          </ProtectedRoute>
        ),
      },
      // Form
      {
        path: "dashboard/form/form-element",
        element: (
          <ProtectedRoute>
            <FormElement />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/form/form-wizard",
        element: (
          <ProtectedRoute>
            <FormWizard />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/form/form-validation",
        element: (
          <ProtectedRoute>
            <FormValidation />
          </ProtectedRoute>
        ),
      },
      // Table
      {
        path: "dashboard/table/bootstrap-table",
        element: (
          <ProtectedRoute>
            <BootstrapTable />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/table/table-data",
        element: (
          <ProtectedRoute>
            <TableData />
          </ProtectedRoute>
        ),
      },
      // Icon
      {
        path: "dashboard/icon/solid",
        element: (
          <ProtectedRoute>
            <Solid />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/icon/outline",
        element: (
          <ProtectedRoute>
            <Outline />
          </ProtectedRoute>
        ),
      },
      {
        path: "dashboard/icon/dual-tone",
        element: (
          <ProtectedRoute>
            <DualTone />
          </ProtectedRoute>
        ),
      },
    ],
  },
];
// const DefaultRouter = () => {
//     return (
//         <TransitionGroup>
//             <CSSTransition classNames="fadein" timeout={300}>
//                 <Switch>
//                     <Route path="/dashboard" exact component={Index} />
//                     {/* user */}
//                     <Route path="/dashboard/app/user-profile"     exact component={UserProfile} />
//                     <Route path="/dashboard/app/user-add"         exact component={UserAdd}/>
//                     <Route path="/dashboard/app/user-list"        exact component={UserList}/>
//                     <Route path="/dashboard/app/user-privacy-setting" exact component={userProfileEdit}/>
//                      {/* widget */}
//                      <Route path="/dashboard/widget/widgetbasic"   exact component={Widgetbasic}/>
//                      <Route path="/dashboard/widget/widgetcard"    exact component={Widgetcard}/>
//                      <Route path="/dashboard/widget/widgetchart"   exact component={Widgetchart}/>
//                      {/* icon */}
//                      <Route path="/dashboard/icon/solid"           exact component={Solid}/>
//                      <Route path="/dashboard/icon/outline"         exact component={Outline}/>
//                      <Route path="/dashboard/icon/dual-tone"       exact component={DualTone}/>
//                      {/* From */}
//                      <Route path="/dashboard/form/form-element"    exact component={FormElement}/>
//                      <Route path="/dashboard/form/form-validation" exact component={FormValidation}/>
//                      <Route path="/dashboard/form/form-wizard"     exact component={FormWizard}/>
//                      {/* table */}
//                      <Route path="/dashboard/table/bootstrap-table" exact component={BootstrapTable}/>
//                      <Route path="/dashboard/table/table-data"      exact component={TableData}/>
//                      {/*special pages */}
//                      <Route path="/dashboard/special-pages/billing" exact component={Billing}/>
//                      <Route path="/dashboard/special-pages/kanban" exact component={Kanban}/>
//                      <Route path="/dashboard/special-pages/pricing" exact component={Pricing}/>
//                      <Route path="/dashboard/special-pages/timeline" exact component={Timeline}/>
//                      <Route path="/dashboard/special-pages/calender" exact component={Calender}/>
//                      {/* map */}
//                      <Route path="/dashboard/map/vector" exact component={Vector}/>
//                      <Route path="/dashboard/map/google" exact component={Google}/>
//                      {/* extra */}
//                      <Route path="/dashboard/extra/privacy-policy" exact component={PrivacyPolicy}/>
//                      <Route path="/dashboard/extra/terms-of-service" exact component={TermsofService}/>
//                      {/*admin*/}
//                      <Route path="/dashboard/admin/admin" exact component={Admin}/>
//                 </Switch>
//             </CSSTransition>
//         </TransitionGroup>
//     )
// }

// export default DefaultRouter
